require('bootstrap');

var Portfolio = function() {
    var $carousel = $('.carousel');
    var $portfolio_projects = $('.portfolio__project');
   
    function init() {
        $carousel.carousel();
        $('.carousel-item .slide').on('click', showCarouselModal);
        $portfolio_projects.on('click', showModal);
    }
    
    function showCarouselModal(e) {
        $carousel.carousel('pause');
        showModal(e);
    }

    function showModal(e) {
        e.stopPropagation();
        var $target = $(e.currentTarget);
        var $modal = $target.find('.portfolio-modal');
        $('body').append('<div class="modal-container">' + $modal.html() + '</div>')
        $('body').addClass('modalOpen');
        $('.portfolio-modal__background').on('click', hideModal);
        $('.portfolio-modal__close-btn').on('click', hideModal);
    }

    function hideModal(e) {
        $carousel.carousel('cycle');
        $('.modal-container').remove();
        $('body').removeClass('modalOpen');
    }

    init();
};

module.exports = Portfolio;